export default __webpack_public_path__ + "static/avatar-2d8e84f24f786b55fa9bb0aab536c133.webp";